import { render, staticRenderFns } from "./Approved.vue?vue&type=template&id=944a47cc&"
import script from "./Approved.vue?vue&type=script&lang=js&"
export * from "./Approved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('944a47cc')) {
      api.createRecord('944a47cc', component.options)
    } else {
      api.reload('944a47cc', component.options)
    }
    module.hot.accept("./Approved.vue?vue&type=template&id=944a47cc&", function () {
      api.rerender('944a47cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Access/Approved/Approved.vue"
export default component.exports